// @flow

import type {CheckedTree, CheckedTreeItem} from '../typedef';

export const findCheckedNodeById = (tree: CheckedTree, id: string): ?CheckedTreeItem => {
    const treeIds = Object.keys(tree);
    if (treeIds.includes(id)) {
        return tree[id];
    } else {
        const node = treeIds.map(subId => {
            if (tree[subId].children) {
                return findCheckedNodeById(tree[subId].children, id);
            }
            return null;
        });

        return node.filter(i => i)[0];
    }
};
